// Note: no .js extension — keep this importable by both Vite/bundler runtimes
// AND by Node when loading vite.config.ts (which goes through esbuild loader).
export * from './site-config';

export type WcagLevel = 'A' | 'AA' | 'AAA';
export type LlmProvider = 'gemini' | 'openai' | 'groq' | 'anthropic' | 'elevenlabs';

export interface SitePublicConfig {
  siteId: string;
  name: string;
  features: Record<FeatureId, boolean>;
  theme: WidgetTheme;
  i18n: { defaultLang: 'he' | 'en' | 'ar' | 'ru'; rtl: boolean };
  ai: { enabled: boolean; providers: LlmProvider[] };
}

export interface WidgetTheme {
  primary: string;
  position: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  size: 'sm' | 'md' | 'lg';
  shape: 'circle' | 'rounded';
}

export type FeatureId =
  | 'text-size'
  | 'spacing'
  | 'contrast'
  | 'highlight-links'
  | 'stop-animations'
  | 'large-cursor'
  | 'keyboard-aids'
  | 'pause-autoplay'
  | 'dyslexia-font'
  | 'tts'
  | 'reading-mask'
  | 'focus-enhance'
  | 'alt-text-ai'
  | 'link-purpose-ai'
  | 'form-labels-ai'
  | 'form-errors-ai'
  | 'simplify-ai'
  | 'translate-ai'
  | 'voice-nav'
  | 'live-captions';

export interface UserPrefs {
  textSizePct?: number;
  lineSpacing?: number;
  letterSpacing?: number;
  contrastMode?: 'off' | 'dark' | 'light' | 'high' | 'invert';
  highlightLinks?: boolean;
  stopAnimations?: boolean;
  cursorSize?: 1 | 2 | 3 | 4;
  dyslexiaFont?: boolean;
  focusEnhance?: boolean;
  readingMask?: boolean;
  enabledAi?: FeatureId[];
}

export const PREFS_KEY = 'nagisot:prefs:v1';
